import { render, staticRenderFns } from "./LabelView.vue?vue&type=template&id=17580d23&scoped=true&"
import script from "./LabelView.vue?vue&type=script&lang=js&"
export * from "./LabelView.vue?vue&type=script&lang=js&"
import style0 from "./LabelView.vue?vue&type=style&index=0&id=17580d23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17580d23",
  null
  
)

export default component.exports